import { render, staticRenderFns } from "./saturation.vue?vue&type=template&id=19941599&"
import script from "./saturation.vue?vue&type=script&lang=js&"
export * from "./saturation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports